import { Link } from 'react-router-dom';
import { istRechtsseite, OEFFENTLICHE_SCHLUESSEL, useRechtsLinks, type Rechtslink } from '../config/legal';

// Paket 12 K12-5 (RSM-17, M-14.8, M-18.6): die Rechtslinks der öffentlichen Seiten aus config/legal.ts, für Anmeldung,
// Registrierung und Einladung gleich. Ohne gültige Adresse kein Link und keine leere Fläche. Die Links nach außen öffnen ein neues
// Fenster, damit eingegebene Formularwerte erhalten bleiben. AV-Vertrag und Support aus legalLinks (Paket 08, EIN-17)
// gehören nicht hierher, sondern in den Bereich „Über“.
// Profil-Nachbau F-20 (PF-785, BAU-RECHT.md 4.4): Die Liste kommt aus useRechtsLinks. Mit veröffentlichter Fassung führen
// Datenschutz und AGB auf die eigene Seite /rechtliches/<slug>, als Link im selben Fenster.
// F-19 (PF-SL3-rahmen-1): mit neuesFenster öffnet auch die eigene Seite ein neues Fenster, etwa im Fuß der Startseite, damit eine
// angefangene Frage erhalten bleibt.
export default function LegalLinks({ className, links, neuesFenster }: { className?: string; links?: Rechtslink[]; neuesFenster?: boolean }) {
  const rechtsLinks = useRechtsLinks();
  const liste = links ?? rechtsLinks.legalLinks().filter(link => OEFFENTLICHE_SCHLUESSEL.includes(link.key));
  if (liste.length === 0) return null;
  const fenster = neuesFenster ? { target: '_blank', rel: 'noopener noreferrer' } : {};

  return (
    <div className={className}>
      <nav aria-label="Rechtliches">
        {liste.map(link => istRechtsseite(link.href)
          ? <Link key={link.key} to={link.href} {...fenster}>{link.label}</Link>
          : <a key={link.key} href={link.href} target="_blank" rel="noopener noreferrer">{link.label}</a>)}
      </nav>
    </div>
  );
}
